"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.picker.tooltip': 'Pick files for AI assistant to use or add your own',
    'knowledge.picker.search.mode': 'Search Mode',
    'knowledge.picker.search.knowledge': 'Knowledge Entries',
    'knowledge.picker.search.projects': 'Projects',
    'knowledge.picker.search.knowledge.label': 'Search Knowledge Entries - assign knowledge to avatar',
    'knowledge.picker.search.knowledge.placeholder': 'Search knowledge entries...',
    'knowledge.picker.search.projects.label': 'Search Projects - assign project to avatar',
    'knowledge.picker.search.projects.placeholder': 'Search projects...',
    'knowledge.picker.search.clear': 'Clear search',
    'knowledge.picker.selected.knowledge': 'Selected Knowledge Entries',
    'knowledge.picker.selected.projects': 'Selected Projects',
    'knowledge.picker.table.name': 'Name',
    'knowledge.picker.table.project': 'Project',
    'knowledge.picker.table.format': 'Format',
    'knowledge.picker.table.size': 'Size',
    'knowledge.picker.table.description': 'Description',
    'knowledge.picker.remove': 'Remove',
    'knowledge.picker.confirmRemove': 'Are you sure you want to remove this knowledge entry?',
    'knowledge.picker.no.results': 'No items found',
    'knowledge.picker.1to1mode': '1:1 Mode (Full Content)',
};
